import { Component, Input, ViewEncapsulation, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../interfaces/app-state.cadastro.interface';
import { NotificationsAction } from '../../../state-management/notifications/notifications.actions';
import { DialogsService } from '../../../services/dialogs.service';

export enum notificationsTypes {
    new = 0,
    error = 1,
    normal = 2,
}
@Component({
    selector: 'notifications-overlay-list--item',
    templateUrl: 'notifications-overlay-list--item.component.html',
    styleUrls: ['notifications-overlay-list--item.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class NotificationsOverlayListItem implements AfterViewInit {

    @Input() public notificationsItens;
    @Input() public activeNotification;

    public notificationsTypes = notificationsTypes;
    public isOppened: boolean = false;

    constructor(
        private store: Store<AppState>,
        private elementRef: ElementRef,
        private dialogService: DialogsService,
    ) {
    }

    public ngAfterViewInit() {
        if (this.activeNotification) {
            const element = this.elementRef.nativeElement.querySelector(`#notification-${this.activeNotification}`);
            setTimeout(() => {
                if (element) {
                    const parent = (element as HTMLElement).ownerDocument.querySelector('md-dialog-container');
                    $(parent)
                        .animate({
                            scrollTop: $(element)
                                .offset().top - ( 40 + 95 ),
                        }, 1200);
                }
            }, 700);
        }
    }

    public readNotification(notification) {
        if (notification.attendence) return;
        if (notification && (notification.readStatus === 0)) {
            notification.readStatus = 1;
            this.store.dispatch({ type: NotificationsAction.readNotification, payload: {
                messageID: notification.messageID,
            } });
        }
    }

    public handleOpen(notification) {
        if (notification.attendence) return;
        this.isOppened = true;
    }

    public handleClose() {
        this.isOppened = false;
    }

}
